import { render, staticRenderFns } from "./TimerComponent.vue?vue&type=template&id=fde7faf8&"
import script from "./TimerComponent.vue?vue&type=script&lang=js&"
export * from "./TimerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports